module.exports = () => {
    require('jquery-mask-plugin');

    var $inputTelefone = $('input[name="telefone_beneficiario"]');
    $inputTelefone.keyup(function () {
        if ($inputTelefone.val().length === 15) {
            $inputTelefone.mask('(00) 90000-0000');
        } else {
            $inputTelefone.mask('(00) 0000-00000');
        }
    }).trigger('keyup');

    var $inputPlaca = $('input[name="placa"]');
    $inputPlaca.mask('SSS0A00');
    $inputPlaca.keyup(function () {
        $inputPlaca.val($inputPlaca.val().toUpperCase());
    });

    $('input[name="valorParticipacao"]').mask('000.000.000.000.000,00', { reverse: true });
};
